export const MIN_SESSIONS_FOR_CHARTS = 5;

export interface LessonSession {
  id: string;
  user_id: string;
  app_name: string;
  practice_mode: string;
  schedule: string | null;
  unit_number: number | null;
  correct_count: number;
  incorrect_count: number;
  out_of_time_count: number;
  missed_count: number;
  total_cards: number;
  accuracy: number;
  average_time: number;
  passed: boolean;
  total_time: number;
  goal_time: number;
  completed_at: string;
}

export interface ProgressChartsProps {
  sessions: LessonSession[];
  isLoading?: boolean;
}

export type TimelineMode = '7d' | '30d' | '90d';
